import { BASE_API_URL } from '../../config';
import { ApiResponse, del, get, patch, post } from '../base';
import {
  CreateStreamEnvironmentRequest,
  StreamEnvironmentResponse,
  StreamEnvironmentsResponse,
  UpdateStreamEnvironmentRequest,
} from './reqres';

export default function StreamEnvironmentService() {
  return Object.freeze({
    listStreamEnvironments(query = ''): Promise<StreamEnvironmentsResponse> {
      return get(
        `${BASE_API_URL()}/stream/environment${query}`
      ) as Promise<StreamEnvironmentsResponse>;
    },
    createStreamEnvironment(
      req: CreateStreamEnvironmentRequest
    ): Promise<StreamEnvironmentResponse> {
      return post(`${BASE_API_URL()}/stream/environment`, req);
    },
    updateStreamEnvironment(
      environmentUuid: string,
      req: UpdateStreamEnvironmentRequest
    ): Promise<StreamEnvironmentResponse> {
      return patch(`${BASE_API_URL()}/stream/environment/${environmentUuid}`, req);
    },
    deleteStreamEnvironment(environmentUuid: string): Promise<ApiResponse> {
      return del(`${BASE_API_URL()}/stream/environment/${environmentUuid}`);
    },
  });
}
